// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "news-4a753f38/chunk-" + {"190": "144b49102acdf44f","288": "c97bc3ea8be0b360","52": "148682781775c445",}[chunkId] + ".js"
}